import React, { useContext, useState } from 'react';
import { Box } from '@mui/material';
import axios from 'axios';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';
import { Colors } from '../../utils/theme';
import { Backup } from '@mui/icons-material';
import DialogBox from '../Common/Layout/DialogBox';
import CancelButton from '../Common/Buttons/CancelButton';
import SaveButton from '../Common/Buttons/SaveButton';
import InputComponent from '../Common/Fields/InputComponent';
import { AppConsts } from '../../enums/AppConsts';

type Props = {
  handleClose: () => void;
};

export default function FtseUpload({ handleClose }: Props) {
  const { dispatch } = useContext(AppContext);
  const [files, setFiles] = useState<File[] | null>(null);
  const [fileNames, setFileNames] = useState('');
  const [date, setDate] = useState<string | null>(null);
  const [dateError, setDateError] = useState<string | null>(null);

  async function getFileDate(file: File) {
    const reader = new FileReader();
    reader.readAsText(file);
    const result = await new Promise((resolve, reject) => {
      reader.onload = function (event) {
        resolve(reader.result);
      };
    });
    return (result as string).substring(0, 10);
  }

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event && event.target && event.target.files) {
      const uploadFiles = Array.from(event.target.files);
      let fileDateString = '' as string | null;
      for (const file of uploadFiles) {
        const fileDate = await getFileDate(file);
        if (fileDateString && fileDateString.length > 0 && fileDateString !== fileDate) {
          setDateError('Files should be only for one date');
          fileDateString = null;
          break;
        }
        fileDateString = fileDate;
        setDateError(null);
      }
      setDate(fileDateString);
      setFiles(uploadFiles);
      const names = uploadFiles.map((f) => f.name).join(', ');
      setFileNames(names);
    } else {
      setFileNames('');
      setDate(null);
      setDateError(null);
    }
  };

  const handleImport = () => {
    if (files) {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append(file.name, file);
      });

      axios({
        method: 'POST',
        url: `${'https://crm.epra.com/csvcollect'}/import`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `${localStorage.getItem(AppConsts.AccessToken)}`
        }
      }).catch((e) => {
        dispatch({
          type: Actions.ShowMessage,
          payload: {
            severity: 'error',
            text: e.message
          }
        });
      });
      dispatch({
        type: Actions.ShowMessage,
        payload: {
          severity: 'info',
          text: `${files.length} File(s) import started`
        }
      });
      handleClose();
    }
  };

  return (
    <DialogBox
      id="ftse-upload-form-dialog"
      width={380}
      title="Import FTSE file"
      onClose={handleClose}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', m: '30px', gap: '10px' }}>
        <InputComponent
          id="ftse-upload-file"
          label=""
          value={fileNames}
          onChange={handleChange}
          errorMsg={dateError}
          disabled
          endAdornment={
            <Box sx={{ position: 'relative', bottom: '3px' }}>
              <input
                accept=".csv"
                id="ftse-file"
                type="file"
                onChange={handleChange}
                style={{ display: 'none' }}
                multiple={true}
              />
              <label htmlFor="ftse-file">
                <Backup
                  style={{
                    cursor: 'pointer',
                    paddingRight: '5%',
                    paddingTop: '5px',
                    color: Colors.main
                  }}
                />
              </label>
            </Box>
          }
        />
        {date && (
          <Box sx={{ position: 'relative', top: '2px', left: '10px', color: Colors.main }}>
            File(s) date: {date}
          </Box>
        )}
        <Box className="centralize" sx={{ gridColumn: 'span 3', marginBottom: '15px', mt: '20px' }}>
          <CancelButton id="cancel-ftse-upload-button" onClick={handleClose} text="Cancel" />
          <SaveButton id="create-new-membership-button" onClick={handleImport} text="Import" />
        </Box>
      </Box>
    </DialogBox>
  );
}
